export default __webpack_public_path__ + "static/media/ico_pin_on_map.d692283a.svg";